const plotlyHoverFormats = {
  TWO_DIGIT_FLOAT: '.2f',
  TWO_DIGIT_ROUND: '.2r',
  ONE_DIGIT_FLOAT: '.1f',
  ONE_DIGIT_ROUND: '.1r',
};

export default plotlyHoverFormats;
